import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const MATCHES_MATCH_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/matches',
        iconClass: 'fas fa-equals',
        name: '::Menu:Matches',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Matches',
      },
    ]);
  };
}
